var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 29,
    viewBox: "0 0 13 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0461 16.2803C12.5263 15.3908 12.5263 14.3194 12.0461 13.4299L6.06577 2.35235C4.76515 -0.0568217 1.39394 0.463598 0.596697 2.73994C0.84714 2.95886 1.07127 3.23082 1.25689 3.55902L6.81032 13.3782C7.32859 14.2946 7.32859 15.4156 6.81032 16.332L1.25688 26.1512C1.07127 26.4794 0.847138 26.7513 0.596695 26.9703C1.39394 29.2466 4.76515 29.767 6.06577 27.3579L12.0461 16.2803Z",
    fill: "#D9D9D9",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract2);
export default __webpack_public_path__ + "static/media/Subtract_2.ba03df02ed9e50bc9b481f599b07b073.svg";
export { ForwardRef as ReactComponent };